import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookingtemp',
  templateUrl: './cookingtemp.component.html',
  styleUrls: ['./cookingtemp.component.css']
})
export class CookingtempComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
